import { TPropsWithChildren } from '@ftd/types'

import { Row, TRowProps } from '@/components/atoms/Row'

export const FormRow: TPropsWithChildren<TRowProps> = ({ children, ...stackProps }) => (
  <Row w="100%" {...stackProps}>
    {children}
  </Row>
)
